/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmailFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    templateId?: boolean;
    subject?: boolean;
    htmlTemplate?: boolean;
    status?: boolean;
    totalRecipients?: boolean;
    sentCount?: boolean;
    failedCount?: boolean;
    batchId?: boolean;
    commonVariables?: boolean;
    attachments?: boolean;
    source?: boolean;
}

